@import 'styles/mixins';

// SCSS variables for shared font styles
$font-family-sohne: Sohne;

// Font mixins for common combinations
@mixin base-font {
  font-family: $font-family-sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.28px;
}

@mixin text-16-400 {
  @include base-font;
  font-size: 16px;
  letter-spacing: 0.32px;
  line-height: 140%;
}

@mixin text-14-400 {
  @include base-font;
}

@mixin text-14-400-139 {
  @include base-font;
  line-height: 139%;
}

@mixin text-14-500 {
  @include base-font;
  font-weight: 500;
  letter-spacing: 0.28px;
}

@mixin text-14-600-110 {
  @include base-font;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: 0.56px;
}

@mixin text-12-500 {
  @include base-font;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.24px;
}

.modalContainer {
  width: 650px !important;
}

.mobileContent {
  padding: 16px !important;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.ctaAndAutoReloadContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
}

.cta {
  background: rgba(79, 98, 248, 0.15);
  border-radius: 10px;
  display: flex;
  padding: 25px;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  align-self: stretch;

  &.no_credits,
  &.negative_credits {
    background: rgba(236, 30, 40, 0.1);
  }
}

.autoReloadContainer {
  align-items: center;
  align-self: stretch;
  border-radius: 10px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding: 11px;

  &.on {
    background: var(--green-10);
  }

  &.off {
    background: var(--dark-3);
  }

  &.paused {
    background: #fcefca;
  }

  .iconTextAndPill {
    display: flex;
    align-items: center;
    gap: 10px;

    .pill {
      @include text-14-600-110;

      display: flex;
      padding: 6px;
      align-items: center;
      border-radius: 6px;

      &.off,
      &.paused {
        border: 1px solid var(--dark-4);
        background: var(--dark-3);
      }

      &.on {
        border: 1px solid var(--dark-4, rgba(0, 0, 0, 0.04));
        background: var(--green-10, rgba(32, 161, 79, 0.1));
      }
    }
  }
}

.manageButtonContainer {
  display: flex;
  align-items: center;
  gap: 10px;

  .budgetStatus {
    color: var(--dark-40);
  }
}

.creditsCount {
  display: flex;
  align-items: center;
  gap: 8px;
}

.expiringWarning {
  color: var(--orange-50) !important;
  @include text-14-400;
  text-align: center;
}

.text {
  color: var(--dark-80);
  @include text-16-400;
}

.planInformation {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 380px;

  &.negative {
    width: 480px;

    span {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  @include for-phone-only {
    width: 100%;
  }
}

.planInformationAndButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  .messageText {
    text-align: center;
  }
}

.refer {
  color: var(--dark-60);
  text-align: center;
  @include text-14-400-139;
  width: 100%;
}

.underline {
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}

.educationContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

.upgradeToGrowthContainer {
  display: flex;
  justify-content: center;
  width: 100%;

  button {
    color: #6a00ff !important;
  }
}

.educationRow {
  width: 100%;
  border-bottom: 1px solid var(--dark-8);

  .textAndChevron {
    cursor: pointer;
    display: flex;
    padding: 10px 0;
    align-items: center;
    gap: 20px;
    align-self: stretch;
  }

  .grow {
    flex-grow: 1;
  }

  .chevronWrapper {
    transition: transform 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &.rotated {
      transform: rotate(180deg);
    }
  }

  .accordionContent {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;

    &.open {
      max-height: 500px; /* Adjust based on your content */
    }
  }

  .accordionInner {
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 0.2s ease 0.1s, transform 0.2s ease 0.1s;
  }

  .accordionContent.open .accordionInner {
    opacity: 1;
    transform: translateY(0);
  }
}

.bottomButtonContainer {
  display: flex;
  justify-content: center;
  width: 100%;
}

.learnMoreTextContainer {
  margin-bottom: 6px;
}

.whatAreCreditsContainer,
.whatUsesCreditsContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 6px;
}

.learnMoreText,
.whatAreCredits,
.creditCost {
  @include text-14-400;
  line-height: 150%;

  a {
    color: var(--dark-80);
  }
}

.contentTypeGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 32px;
  margin-bottom: 10px;
}

.contentTypeRow {
  display: flex;
  align-items: center;
  gap: 11px;
  width: calc(50% - 16px);
}

.contentTypeInfo {
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.contentTypeName {
  flex: 1;
  color: var(--dark-90);
}

.contentTypeCost {
  color: var(--dark-60);
  white-space: nowrap;
}

.buttonWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
}
